/* istanbul ignore file */
export async function sleep(interval: number): Promise<void> {
  await new Promise(r => setTimeout(r, interval))
}
